import axios, { AxiosResponse } from 'axios';
import { config } from 'process';
import React, { useContext, useEffect, useState } from 'react';
import { API_ENDPOINT } from '../../../../../configurations/global.config';
import { DriverType } from '../../../../../interfaces/delivery-company/drivers';
import {
  CompactMerchantType,
  MerchantType,
} from '../../../../../interfaces/delivery-company/merchants';
import { AuthContext } from '../../../../../contexts/user-context/user-context';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Popover,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Typography,
  TablePagination,
  Alert,
  Button,
  LinearProgress,
  Chip,
  Box,
} from '@mui/material';
import {
  DeliveryState,
  PaymentState,
  Workflow,
} from '../../../../../enums/orders';
import AutocompleteWithThrottle from '../../../../common/autocomplete-with-throttle/autocomplete-with-throttle';
import { OrderType } from '../../../../../interfaces/delivery-company/orders';
import {
  ActorFilterOption,
  DeliveryStateFilterOption,
  FilterKey,
  IFilterOption,
  PaymentStateFilterOption,
} from '../../../../common/filter-bar/types';
import { Updater, useImmer } from 'use-immer';
import {
  DoubleDate,
  DoubleDateMode,
  DoubleDateWithMode,
} from '../../../../common/double-date-picker/double-date-picker.interfaces';
import { PaginationContext } from '../../../../../contexts/pagination-context';
import { buildQueryParams } from '../../../../common/filter-bar/filter-bar.utils';
import DoubleDatePicker from '../../../../common/double-date-picker/double-date-picker';
import FilterBar from '../../../../common/filter-bar/filter-bar';
import SearchBar from '../../../../common/search-bar/search-bar';
import { searchOptions } from '../../../customers/customers.config';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { isMobile, isTablet } from 'react-device-detect';
import { ErrorsFlattenner } from '../../../../common/errors-flattenner/errors-flattenner';
import GenericTable from '../../../../common/generic-table/generic-table';
import {
  displayLocation,
  displayMultipleLocations,
} from '../../../../../utils/locations';
import { showDeliveryState } from '../../../../common/styles/order-states.style';
import orders from '../../../orders/orders';
import { OrderDeliveryTaskState, PickupTaskState } from '../../../../../enums/tasks';
import { IOrderDeliveryTask, IPickupTask } from '../../../../../interfaces/delivery-company/tasks';
import { format, formatDate } from 'date-fns';
import { ColumnConfig } from '../../../../common/generic-table/utils';
import { showWorkflow } from '../../../../common/styles/workflow-display';
import DoubleDateOrdersFilter from '../../../../common/double-date-orders-filter/double-date-orders-filter';
import { generateDateFilterQueryParam } from '../../../../common/double-date-orders-filter/utils';
import { Checklist } from '@mui/icons-material';
import OrderNotes from '../../../../common/order-notes/order-notes';
import IncompleteAddressError from '../../../../common/incomplete-address-error/incomplete-address-error';
import { IMerchantOrdersInvoice } from '../../../../../interfaces/common/merchant-invoices';
import { DriverInvoiceType, IDriverInvoice } from '../../../../../interfaces/common/driver-invoices';
import { useSnackBar } from '../../../../../contexts/snackbar';
import { displayMoney, Money } from '../../../../../utils/money';
import UpdateCommissionDialog from '../../../../common/delivery-task-commission/update-commission-dialog';
import { get_cod } from '../../../../../utils/cod';
import DriverAmountsSummary from '../driver-amounts-summary';

interface InvoiceableDeliveryTasksProps {
  driver: DriverType;
  selectedItems: Map<string, IOrderDeliveryTask>;
  updateSelectedItems: Updater<Map<string, IOrderDeliveryTask>>;
  invoicePurpose: 'NET' | 'COLLECTION' | 'COMMISSION';
}

function InvoiceableDeliveryTasks({
  driver,
  selectedItems,
  updateSelectedItems,
  invoicePurpose
}: InvoiceableDeliveryTasksProps) {
  const [itemsList, setItemsList] = useState<IOrderDeliveryTask[]>();
  const [itemsCount, setIemsCount] = useState<number>(0);
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [filters, setFilters] = useState<IFilterOption[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {showMessage} = useSnackBar()
  const [updateCommissionFor, setUpdateCommissionFor] = useState<IOrderDeliveryTask | null>(null);

  console.log("tasks = ", itemsList)

  const [dateFilter, setDateFilter] = useState<DoubleDateWithMode>({
    startDate: null,
    endDate: null,
    mode: DoubleDateMode.DELIVERY_DATE,
  });

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 1000,
  });

  const totalSelected = selectedItems.size;

  const { user, config } = useContext(AuthContext);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setController({
      ...controller,
      rowsPerPage: newRowsPerPage,
      page: 0,
    });
  };
  const resetPaginationControls = () => {
    setController({
      ...controller,
      page: 0,
    });
  };

  const resetSelectionState = () => {
    updateSelectedItems((selectedItems) => {
      selectedItems.clear();
    });
  };

  const filterQueryAction = (filters: IFilterOption[]) => {
    resetPaginationControls();
    setFilters(filters);
    resetSelectionState();
  };

  const dateFilterAction = (dateFilterValue: DoubleDateWithMode) => {
    resetPaginationControls();
    setDateFilter(dateFilterValue);
  };

  const resetAll = () => {
    resetPaginationControls();
    resetSelectionState();
  };

  // Fetching delivery tasks.
  useEffect(() => {
    let response: any;
    const getData = async () => {
      let endpoint = `${API_ENDPOINT}/v1/delivery-tasks/?page=${controller.page + 1}&page_size=${controller.rowsPerPage}&driver=${driver.id}&invoiceable_with_purpose=${invoicePurpose}`;
      
      resetSelectionState()
      const filterQueryParams = buildQueryParams(filters);
      endpoint += `${filterQueryParams}`;
      endpoint += `&${generateDateFilterQueryParam(dateFilter)}`;

      try {
        response = await axios.get<{ count: number; results: IOrderDeliveryTask[] }>(
          endpoint,
          config
        );
          setItemsList(response.data.results);
          setIemsCount(response.data.count);
      } catch (error) {
        showMessage("Failed to load orders", 'error')
      }
      setIsLoading(false);
    };
    setIsLoading(true);
    getData();
    console.log(response);
  }, [dateFilter, filters, JSON.stringify(controller), invoicePurpose]);


  return (
    <div>
      <Card sx={{ padding: 2 }} elevation={0}>
        {message !== '' && (
          <>
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>

            <br />
          </>
        )}

        <Accordion elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography
              variant="h5"
              component="h5"
              sx={{ textAlign: 'center', mt: 1, mb: 1 }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <ManageSearchIcon fontSize="large" color="primary" />
                <span>
                  <b>Search and Filter Controls</b>
                </span>
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DoubleDateOrdersFilter dateFilterAction={dateFilterAction} />
            <br />


            <FilterBar
                filterQueryAction={filterQueryAction}
                currentlySelectedFilters={filters}
                filterKeys={["customer", "merchant", "workflow", "district", "governorate"]}
            />
        
          </AccordionDetails>
        </Accordion>

        {isLoading ? (
          <LinearProgress />
        ) : (
          <>
            {itemsList ? (
              <>
              <Box display={"flex"} width={"100%"} justifyContent={"space-between"} alignItems={"center"} sx={{mb:2}}>

                 <Chip
                  icon={<Checklist />}
                  color="primary"
                  label={`Selected ${totalSelected}/${itemsCount}`}
                  variant={
                    totalSelected === itemsCount && totalSelected > 0
                      ? 'filled'
                      : 'outlined'
                  }
                />
                

              </Box>
               
                <GenericTable<IOrderDeliveryTask>
                  sourceView="create-new-driver-delivery-invoice"
                  items={[
                    ...itemsList.filter(item => item.status == OrderDeliveryTaskState.FAILED),
                    ...itemsList.filter(item => item.status == OrderDeliveryTaskState.COMPLETED),
                    ]
                }
                  selectedItems={selectedItems}
                  updateSelectedItems={updateSelectedItems}
                  isLoading={isLoading}
                  fullWidth
                  selectionEnabled
                  columns= {[
                      {
                        id: 'order_id',
                        header: 'Order ID',
                        display_body: (deliveryAttempt) => (
                            <a href={`/order/${deliveryAttempt.order.id}`}>
                            <b>
                            {deliveryAttempt.order.order_id}
                            {deliveryAttempt.order.reference_id && deliveryAttempt.order.reference_id.length > 0 && (
                                <>
                                <br />({deliveryAttempt.order.reference_id})
                                </>
                            )}{' '}
                            </b>
                        </a>
                        ),
                      },
                      
                      {
                        id: 'attempt_id',
                        header: 'Attempt ID',
                        display_body: (deliveryAttempt) => deliveryAttempt.id,
                      },
                      {
                        id: 'customer',
                        header: 'Customer',
                        display_body: (deliveryAttempt) => (
                          <>
                            {deliveryAttempt.order.customer?.name}
                          </>
                        ),
                      },
                      {
                        id: 'merchant',
                        header: 'Merchant',
                        display_body: (deliveryAttempt) => (
                          <>
                            {deliveryAttempt.order.merchant?.name}
                          </>
                        ),
                      },
                      {
                        id: 'delivery_status',
                        header: 'Delivery Result',
                        display_body: (deliveryAttempt) => deliveryAttempt.status == OrderDeliveryTaskState.FAILED ? 
                            <Chip color={'error'} label={"Failed"} /> 
                            :
                            <Chip color={'success'} label={"Successful"} /> 
                      },
                      {
                            id: 'notes',
                            header: 'Notes',
                            display_body: (attempt: IOrderDeliveryTask) => (
                             <>
                              {!attempt.order.customer_location?.area && <IncompleteAddressError /> }
                              <OrderNotes order={attempt.order} />
                            </>
                            ),
                      },
                      {
                        id: 'workflow',
                        header: 'Workflow',
                        display_body: (deliveryAttempt) =>
                          showWorkflow(
                            deliveryAttempt.order.workflow,
                            deliveryAttempt.order.is_exchange,
                            deliveryAttempt.order.exchange_for,
                            deliveryAttempt.order.return_reason
                          ),
                      },
                      {
                        id: 'failure_reason',
                        header: 'Failure Reason',
                        display_body: (deliveryAttempt) => {
                            if (deliveryAttempt.status == OrderDeliveryTaskState.COMPLETED) return null
                          return (
                            <Box sx={{ display: 'inline-block' }}>
                              <Chip
                                label={deliveryAttempt.failure_reason ?? 'No Reason' }
                                sx={{
                                  backgroundColor: '#e0e0e0',
                                  margin: 0.5, // Adjust chip margin
                                }}
                              />
                            </Box>
                          );
                        },
                      },
                      {
                        id: 'failure_commission',
                        header: 'Driver Commission',
                        display_body: (deliveryAttempt) => {
                          return (
                            <Box sx={{ display: 'inline-block' }}>
                                <Box
                                  onClick={() =>
                                    setUpdateCommissionFor(deliveryAttempt)
                                  }
                                  sx={{
                                    display: 'inline-block',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 1,
                                    bgcolor: 'grey.100',
                                    color: 'text.primary',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                      bgcolor: 'grey.200',
                                    },
                                  }}
                                >
                                  {displayMoney(deliveryAttempt.status == OrderDeliveryTaskState.COMPLETED ? deliveryAttempt.driver_commission : deliveryAttempt.failed_delivery_commission)}
                                </Box>
                            </Box>
                          );
                        },
                      },
                      {
                        id: 'cod',
                        header: 'COD',
                        display_body: (deliveryAttempt) => {
                            if (deliveryAttempt.status == OrderDeliveryTaskState.FAILED) return "-"
                            return displayMoney(get_cod(deliveryAttempt.order))
                        }
                      },
                      {
                        id: 'delivery_date',
                        header: 'Delivery Date',
                        display_body: (deliveryAttempt) => <Box> {formatDate(deliveryAttempt.order.delivered_at!, 'dd-MM-yyyy')}</Box>
                      }
                    ]}
                    getItemUID={(order) => order.id}
                />

                <TablePagination
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={itemsCount}
                  rowsPerPage={controller.rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 250, 500, 1000]}
                  labelRowsPerPage=""
                  style={{ overflow: 'visible' }}
                />
                {updateCommissionFor && (
                    <UpdateCommissionDialog 
                    // should update commission as a failing task
                    task={updateCommissionFor!} 
                    updateDeliveryTaskCommission={function (m: Money[]): void {
                        const newTask = {
                            ...updateCommissionFor,
                            driver_commission: updateCommissionFor.status == OrderDeliveryTaskState.FAILED ? updateCommissionFor.driver_commission : m,
                            failed_delivery_commission: updateCommissionFor.status == OrderDeliveryTaskState.FAILED ? m : updateCommissionFor.driver_commission,
                        }
                        setItemsList(itemsList.map(item => item.id != updateCommissionFor.id ? item : newTask))
                        
                        const newSelectedItems = new Map(selectedItems)
                        newSelectedItems.set(updateCommissionFor.id,  newTask)
                        updateSelectedItems(newSelectedItems)
                    } } 
                    onClose={()=>setUpdateCommissionFor(null)} />
                
                )}
              </>
            ) : (
              <Alert severity="error">Failed to load orders</Alert>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default InvoiceableDeliveryTasks;
